import React from 'react';
import '../styles/pages/PolicyPage.css';

function RefundPolicyPage() {
  return (
    <div className="policy-page">
      <div className="policy-page__container">
        <header className="policy-page__header">
          <h1 className="policy-page__title">셀프애드 환불 정책</h1>
          <p className="policy-page__date">최종 수정일: 2026년 2월 4일</p>
        </header>

        <div className="policy-page__intro">
          <p>(주)카보(이하 "회사")가 운영하는 셀프애드의 포인트 충전 및 환불에 관한 정책은 다음과 같습니다.</p>
        </div>

        {/* 목차 */}
        <nav className="policy-page__toc">
          <h2 className="policy-page__toc-title">목차</h2>
          <ul className="policy-page__toc-list">
            <li><a href="#article-1">제1조 (목적)</a></li>
            <li><a href="#article-2">제2조 (포인트 충전)</a></li>
            <li><a href="#article-3">제3조 (환불 가능 조건)</a></li>
            <li><a href="#article-4">제4조 (환불 불가 조건)</a></li>
            <li><a href="#article-5">제5조 (환불 수수료 및 금액)</a></li>
            <li><a href="#article-6">제6조 (환불 절차)</a></li>
            <li><a href="#article-7">제7조 (환불 취소)</a></li>
            <li><a href="#article-8">제8조 (프로젝트 관련 환불)</a></li>
            <li><a href="#article-9">제9조 (회원 탈퇴 시 환불)</a></li>
            <li><a href="#article-10">제10조 (결제 취소 및 청약 철회)</a></li>
            <li><a href="#article-11">제11조 (환불 지연 시 조치)</a></li>
            <li><a href="#article-12">제12조 (분쟁 해결)</a></li>
            <li><a href="#article-13">제13조 (정책 변경)</a></li>
            <li><a href="#article-14">제14조 (문의)</a></li>
          </ul>
        </nav>

        {/* 본문 */}
        <div className="policy-page__content">
          <section id="article-1" className="policy-page__section">
            <h2 className="policy-page__section-title">제1조 (목적)</h2>
            <p>본 환불 정책은 회원이 충전한 포인트의 환불 조건 및 절차를 명확히 하여 회원과 회사 간의 분쟁을 예방하고, 회원의 권익을 보호하기 위함입니다.</p>
          </section>

          <section id="article-2" className="policy-page__section">
            <h2 className="policy-page__section-title">제2조 (포인트 충전)</h2>
            <ol className="policy-page__list">
              <li>회원은 플랫폼 내에서 포인트를 충전할 수 있으며, 1포인트는 1원의 가치를 가집니다.</li>
              <li>포인트 충전은 신용카드, 계좌이체 등 회사가 제공하는 결제수단을 통해 가능합니다.</li>
              <li>충전된 포인트의 유효기간은 충전일로부터 5년입니다.</li>
            </ol>
          </section>

          <section id="article-3" className="policy-page__section">
            <h2 className="policy-page__section-title">제3조 (환불 가능 조건)</h2>
            <p>다음 각 호의 경우 포인트 환불이 가능합니다.</p>
            <ol className="policy-page__list">
              <li>회원이 사용하지 않은 잔여 포인트가 있는 경우</li>
              <li>최소 환불 가능 포인트: 10,000포인트 이상</li>
              <li>진행 중인 프로젝트가 없는 경우</li>
              <li>법령에 따라 환불이 필요한 경우</li>
            </ol>
          </section>

          <section id="article-4" className="policy-page__section">
            <h2 className="policy-page__section-title">제4조 (환불 불가 조건)</h2>
            <p>다음 각 호의 경우 포인트 환불이 불가능합니다.</p>
            <ol className="policy-page__list">
              <li>이미 프로젝트에 사용된 포인트</li>
              <li>최소 환불 포인트(10,000포인트) 미만</li>
              <li>진행 중인 프로젝트가 있는 경우</li>
              <li>회원이 약관을 위반하여 회원자격이 정지된 경우</li>
              <li>부정한 방법으로 획득한 포인트</li>
              <li>이벤트나 프로모션으로 무상 지급받은 포인트</li>
            </ol>
          </section>

          <section id="article-5" className="policy-page__section">
            <h2 className="policy-page__section-title">제5조 (환불 수수료 및 금액)</h2>
            <ol className="policy-page__list">
              <li>환불 시 회원에게 부가세를 포함하여, 충전 금액의 110%를 환불합니다.</li>
              <li>환불 금액은 다음과 같이 계산됩니다:
                <ul className="policy-page__sublist">
                  <li>환불 금액 = 환불 신청 포인트 × 1.1 (원)</li>
                </ul>
              </li>
              <li>환불 금액은 회원이 등록한 은행 계좌로 입금됩니다.</li>
            </ol>
          </section>

          <section id="article-6" className="policy-page__section">
            <h2 className="policy-page__section-title">제6조 (환불 절차)</h2>
            <ol className="policy-page__list">
              <li>회원은 플랫폼 내 "포인트 환불하기" 메뉴에서 환불을 신청할 수 있습니다.</li>
              <li>환불 신청 시 다음 정보를 입력해야 합니다:
                <ul className="policy-page__sublist">
                  <li>환불 희망 포인트</li>
                  <li>환불 받을 은행 계좌 정보 (예금주명, 은행명, 계좌번호)</li>
                </ul>
              </li>
              <li>환불 신청이 접수되면 즉시 해당 포인트가 차감됩니다.</li>
              <li>회사는 환불 신청을 검토한 후, 영업일 기준 3~5일 내에 환불 처리합니다.</li>
              <li>환불이 완료되면 회원이 등록한 통신수단을 통해 통보합니다.</li>
            </ol>
          </section>

          <section id="article-7" className="policy-page__section">
            <h2 className="policy-page__section-title">제7조 (환불 취소)</h2>
            <ol className="policy-page__list">
              <li>환불 신청 후 처리 전까지는 취소가 가능합니다.</li>
              <li>이미 환불이 완료된 경우 취소가 불가능합니다.</li>
            </ol>
          </section>

          <section id="article-8" className="policy-page__section">
            <h2 className="policy-page__section-title">제8조 (프로젝트 관련 환불)</h2>
            <ol className="policy-page__list">
              <li>
                <strong>프로젝트 계약이 체결되지 않은 경우</strong>
                <p>광고주에게 전액 포인트로 환불됩니다.</p>
              </li>
              <li>
                <strong>프로젝트가 중도 취소된 경우</strong>
                <ul className="policy-page__sublist">
                  <li>인플루언서의 귀책사유: 광고주에게 전액 포인트 환불</li>
                  <li>광고주의 귀책사유: 인플루언서에게 계약금의 일부 또는 전부 포인트로 지급</li>
                  <li>쌍방 합의: 합의 내용에 따라 처리</li>
                </ul>
              </li>
              <li>
                <strong>프로젝트 완료 후 목표 미달성 시</strong>
                <ul className="policy-page__sublist">
                  <li>미달성 부분에 대해서는 광고주에게 자동 포인트 환불됩니다.</li>
                  <li>CPS(성과형) 프로젝트의 경우, 미사용 보증금은 프로젝트 종료 후 포인트 환불됩니다.</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-9" className="policy-page__section">
            <h2 className="policy-page__section-title">제9조 (회원 탈퇴 시 환불)</h2>
            <ol className="policy-page__list">
              <li>회원 탈퇴 시 잔여 포인트가 10,000포인트 이상인 경우 환불 신청이 가능합니다.</li>
              <li>환불 신청 없이 탈퇴하는 경우, 잔여 포인트는 소멸됩니다.</li>
              <li>탈퇴 후 재가입하더라도 소멸된 포인트는 복구되지 않습니다.</li>
            </ol>
          </section>

          <section id="article-10" className="policy-page__section">
            <h2 className="policy-page__section-title">제10조 (결제 취소 및 청약 철회)</h2>
            <ol className="policy-page__list">
              <li>전자상거래법에 따라 포인트 충전 후 7일 이내에는 청약 철회(환불)가 가능합니다.</li>
              <li>단, 이미 포인트를 사용한 경우에는 사용한 포인트를 제외한 금액만 환불됩니다.</li>
              <li>청약 철회 신청은 고객센터를 통해 가능합니다.</li>
            </ol>
          </section>

          <section id="article-11" className="policy-page__section">
            <h2 className="policy-page__section-title">제11조 (환불 지연 시 조치)</h2>
            <ol className="policy-page__list">
              <li>회사의 귀책사유로 환불이 지연되는 경우, 지연 기간에 대해 「전자상거래 등에서의 소비자보호에 관한 법률」에 따른 지연이자를 지급합니다.</li>
              <li>지연이자율: 연 15%</li>
            </ol>
          </section>

          <section id="article-12" className="policy-page__section">
            <h2 className="policy-page__section-title">제12조 (분쟁 해결)</h2>
            <ol className="policy-page__list">
              <li>환불과 관련하여 분쟁이 발생한 경우, 회사와 회원은 상호 협의하여 해결하도록 노력합니다.</li>
              <li>협의가 이루어지지 않는 경우, 한국소비자원, 전자거래분쟁조정위원회 등을 통해 분쟁을 조정할 수 있습니다.</li>
            </ol>
          </section>

          <section id="article-13" className="policy-page__section">
            <h2 className="policy-page__section-title">제13조 (정책 변경)</h2>
            <ol className="policy-page__list">
              <li>본 환불 정책은 관련 법령 및 회사의 정책 변경에 따라 변경될 수 있습니다.</li>
              <li>정책이 변경되는 경우, 변경 내용을 적용일 30일 전부터 공지합니다.</li>
            </ol>
          </section>

          <section id="article-14" className="policy-page__section">
            <h2 className="policy-page__section-title">제14조 (문의)</h2>
            <p>환불과 관련하여 문의사항이 있는 경우, 다음 연락처로 문의하시기 바랍니다.</p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">부칙</h2>
            <p>본 환불 정책은 2026년 2월 4일부터 시행됩니다.</p>
          </section>
        </div>

        {/* 사업자 정보 */}
        <footer className="policy-page__business-info">
          <h2 className="policy-page__business-info-title">사업자 정보</h2>
          <div className="policy-page__business-info-content">
            <p><strong>상호명:</strong> (주)카보</p>
            <p><strong>사업자등록번호:</strong> 291-86-02840</p>
            <p><strong>대표자:</strong> 이동진</p>
            <p><strong>주소:</strong> 충청남도 계룡시 장안1길 6, 202호</p>
            <p><strong>전화번호:</strong> 044-715-7442</p>
            <p><strong>이메일:</strong> ldjs35@daum.net</p>
            <p><strong>영업시간:</strong> 평일 10:00~17:00</p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default RefundPolicyPage;
